<template>
    <div :class="className" @click="onClick">
        <span class="open">{{ openName }}</span>
        <span class="close">{{ closeName }}</span>
    </div>

</template>

<script>
'use strict';

export default {
	props: {
		value: {
			default: true,
		},
		// sm md lg
		size: {
			type: String,
			default: 'sm'
		},
		// blue red green orange
		color: {
			type: String,
			default: 'blue'
		},
		openValue: {
			default: true
		},
		closeValue: {
			default: false
		},
		openName: {
			type: String,
			default: ''
		},
		closeName: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		className() {
			let {
				value,
				openValue,
				closeValue,
				size,
				color,
				disabled
			} = this;
			return {
				'vue-switch': true,
				'z-on': value === openValue,
				'z-disabled': disabled,
				['s-' + size]: true,
				['c-' + color]: true
			};
		}
	},
	methods: {
		onClick() {
			let {
				disabled,
				value,
				openValue,
				closeValue
			} = this;
			if (!disabled) {
				if (openValue === value) {
					this.$emit('input', closeValue);
				} else {
					this.$emit('input', openValue);
				}
			}
		}
	}
}

</script>

<style lang="sass" scoped>@import "./switch.scss"</style>
